import { AutoCompleteSelect } from 'aa_common/front-end/antd'
import { If } from 'aa_common/front-end/components'
import { IMPAIRMENT_LOSS_APPLY_METHOD } from 'common/constants'
import { getNs } from 'common/i18n-config'
import { LedgerSettingsItem } from 'common/models'
import Form from 'components/molecules/Form'
import { get, isEqual } from 'lodash'
import { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { selectMasterData } from 'store/masterData/selectors'

import { FIELD_NAMES } from '../validation'

const { FormField } = Form
const { SELECT_ON_IMPAIRMENT } = IMPAIRMENT_LOSS_APPLY_METHOD

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment', 'common'])

type ImpairmentMethodProps = {
  ledgerSetting?: LedgerSettingsItem
}

export const ImpairmentMethod = ({ ledgerSetting }: ImpairmentMethodProps) => {
  useNsReady()
  const { control, errors, setValue } = useFormContext()

  const { impairment_loss_apply_method } = useSelector(selectMasterData, isEqual)
  const impairmentMethods = useMemo(() => {
    return impairment_loss_apply_method.filter(item => item.code !== SELECT_ON_IMPAIRMENT)
  }, [impairment_loss_apply_method])

  const isSelectMethodOnImpair = ledgerSetting?.impairment_loss_apply_method === SELECT_ON_IMPAIRMENT

  useEffect(() => {
    const method = ledgerSetting?.impairment_loss_apply_method
    if (method && !isSelectMethodOnImpair) {
      // Need this hack to wait for useWatch being ready
      setTimeout(() => {
        setValue(FIELD_NAMES.impairment_method, method)
      }, 0)
    }
  }, [setValue, isSelectMethodOnImpair, ledgerSetting?.impairment_loss_apply_method])

  return (
    <If condition={isSelectMethodOnImpair}>
      <FormField title={t('impairment_depreciation_method')} required>
        <AutoCompleteSelect
          required
          name={FIELD_NAMES.impairment_method}
          valueField="code"
          textField="name_jp"
          placeholder={t('placeholder.please_select')}
          items={impairmentMethods}
          error={get(errors, 'impairment_method.message')}
          control={control}
        />
      </FormField>
    </If>
  )
}
